export default __webpack_public_path__ + "static/media/mitra.160309d7.jpg";